import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { additionalInfoData } from "../../../../services/packageService";
import Toster from "../../../common/Toster";
import TinyEditor from "../../../Editor/TinyEditor";
import { pbEditorWrap } from "../packageBuilderUi";

const AdditionalInfo = ({ setAdditionalInfoData, packageid, onUserEdit }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [error] = useState("");
  const [successMessage] = useState("");
  const [content, setContent] = useState("");

  const { data: additionalInfo } = useQuery({
    queryKey: ["additionalInfo", packageid],
    queryFn: () => additionalInfoData(packageid),
    enabled: !!packageid,
  });

  useEffect(() => {
    if (additionalInfo?.data?.additional_info) {
      setContent(additionalInfo.data.additional_info);
      setAdditionalInfoData({
        packageid: packageid,
        additional_info: additionalInfo.data.additional_info,
      });
    }
  }, [additionalInfo, packageid, setAdditionalInfoData]);

  const handleEditorChange = (newContent) => {
    onUserEdit?.();
    setContent(newContent);
    setAdditionalInfoData({
      packageid: packageid,
      additional_info: newContent,
    });
  };

  return (
    <>
      {showError && error && (
        <Toster
          message={error}
          type="error"
          duration={3000}
          onClose={() => setShowError(false)}
        />
      )}
      {showSuccess && successMessage && (
        <Toster
          message={successMessage}
          type="success"
          duration={3000}
          onClose={() => setShowSuccess(false)}
        />
      )}

      <div className="space-y-3">
        <label className="block text-sm font-medium text-gray-700">
          Description
        </label>
        <div className={pbEditorWrap}>
          <TinyEditor
            className="package-field-text"
            value={content}
            onChange={handleEditorChange}
            height={400}
          />
        </div>
      </div>
    </>
  );
};

export default AdditionalInfo;
